import { cva } from "class-variance-authority";
import React from "react";
import { ICONS } from "utils/constants";

const popupCVA = cva("", {
  variants: {
    isOpen: {
      true: "si-active",
    },
    type: {
      modal: "si-modal",
      popup: "si-popup",
    },
  },
  compoundVariants: [
    {
      open: true,
      type: "modal",
      class: "si-active",
    },
    {
      open: true,
      type: "popup",
      class: "si-active",
    },
  ],
  defaultVariants: {
    open: false,
  },
});

const Popup = ({ isOpen, handleClose, showCloseIcon, children }) => {
  return (
    <div className={popupCVA({ isOpen, type: "modal" })}>
      <div className={popupCVA({ isOpen, type: "popup" })}>
        {showCloseIcon && (
          <div onClick={handleClose} className="si-popup__close">
            <i className={ICONS.CLOSE}></i>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

Popup.Body = ({ children }) => {
  return <div className="si-popup__body">{children}</div>;
};

Popup.Heading = ({ children }) => {
  return <div className="si-popup__heading">{children}</div>;
};

Popup.Desc = ({ children }) => {
  return <div className="si-popup__desc">{children}</div>;
};

export { Popup };
